import { render, staticRenderFns } from "./CmpLotForm.vue?vue&type=template&id=5ca952a6&scoped=true&"
import script from "./CmpLotForm.vue?vue&type=script&lang=js&"
export * from "./CmpLotForm.vue?vue&type=script&lang=js&"
import style0 from "./CmpLotForm.vue?vue&type=style&index=0&id=5ca952a6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca952a6",
  null
  
)

export default component.exports